var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-products',{attrs:{"products":_vm.order.products},on:{"update:products":function($event){return _vm.$set(_vm.order, "products", $event)},"changePreTaxAmount":_vm.changePreTaxAmount}})}
var staticRenderFns = []

export { render, staticRenderFns }